import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './legend.module.scss';
import classNames from 'classnames';
import { Lx } from '../../../../../../i18n/consts';
import { VacationState } from '../../../../../../features/vacation/types';

interface Props {
    className?: string;
}

interface LegendItem {
    color: string;
    label: string;
}

export const getVacationStateColor = (state: VacationState): string => {
    let color = '';
    switch (state) {
        case VacationState.WaitApprove:
            color = 'waitapprove';
            break;
        case VacationState.ApprovedByCurrentUser:
            color = 'approvedByCurrentUser';
            break;
        case VacationState.Approved:
            color = 'approved';
            break;
    }

    return color;
};

const Legend: React.FC<Props> = ({ className }) => {
    const legendData: LegendItem[] = [
        { color: getVacationStateColor(VacationState.WaitApprove), label: Lx.Vacation.STATE_WAIT_APPROVE },
        { color: getVacationStateColor(VacationState.ApprovedByCurrentUser), label: Lx.Vacation.STATE_APPROVED_BY_YOU },
        { color: getVacationStateColor(VacationState.Approved), label: Lx.Vacation.STATE_APPROVED }
    ];

    return (
        <div className={classNames(styles.legend, className)}>
            {legendData.map((item) => (
                <div className={styles.legendItem} key={item.label}>
                    <span
                        className={classNames(styles.dotWrapper, {
                            [styles.waitApprove]: item.color === 'waitapprove',
                            [styles.approvedByCurrentUser]: item.color === 'approvedByCurrentUser',
                            [styles.approved]: item.color === 'approved'
                        })}
                    >
                        <span className={styles.dot} />
                    </span>
                    <span className={styles.label}>
                        &ndash; <FormattedMessage id={item.label} />
                    </span>
                </div>
            ))}
        </div>
    );
};

export default Legend;
